import { Analytics } from "@vercel/analytics/react";

function Maintenance() {
  return (
    <>
      <Analytics />
      <div className="bg-white min-h-screen flex items-center justify-center px-8">
        <p className="text-black text-center text-lg">
          This page is currently in the maintenance mode. Try again later.
        </p>
      </div>
    </>
  );
}

export default Maintenance;
